module.exports = __webpack_public_path__ + "img/eye-close.svg";